@if (isLastStepperComponent) {
<div class="btn-group drop-button">
  <button
    mat-flat-button
    class="save-dropdown-btn"
    (click)="onSaveAndCloseClicked($event)"
    [disabled]="isDisabled"
    [color]="isDisabled ? 'secondary' : 'primary'"
  >
    {{ 'app.button.label.saveAndClose' | translate }}
  </button>
  <button
    mat-flat-button
    [matMenuTriggerFor]="menu"
    class="button-as-trigger"
    [color]="isDisabled ? 'secondary' : 'primary'"
    [disabled]="isDisabled"
  >
    <span class="sif sif-chevron-s"></span>
  </button>
  <mat-menu #menu="matMenu" xPosition="before" class="save-close-menu-dropdown" #dropdownList>
    <button mat-menu-item (click)="onSaveClicked($event)">
      {{ 'app.button.label.save' | translate }}
    </button>
  </mat-menu>
</div>
} @else { @if (!isEasyPlan && isLocked) {
<div class="btn-group">
  <button
    mat-flat-button
    color="primary"
    class="ml-0 mt-0 next-button"
    (click)="onNextClicked($event)"
  >
    {{ 'app.button.label.next' | translate }}
  </button>
</div>
} @else {
<div class="btn-group drop-button">
  <button
    mat-flat-button
    class="save-dropdown-btn"
    (click)="onSaveAndNextClicked($event)"
    [disabled]="isDisabled"
    [color]="isDisabled ? 'secondary' : 'primary'"
  >
    {{ 'app.button.label.saveAndNext' | translate }}
  </button>
  <button
    mat-flat-button
    [matMenuTriggerFor]="menu"
    class="button-as-trigger"
    [color]="isDisabled ? 'secondary' : 'primary'"
    [disabled]="isDisabled"
  >
    <span class="sif sif-chevron-s"></span>
  </button>
  <mat-menu #menu="matMenu" xPosition="before" class="save-close-menu-dropdown" #dropdownList>
    <button mat-menu-item (click)="onSaveClicked($event)">
      {{ 'app.button.label.save' | translate }}
    </button>
    <button mat-menu-item (click)="onSaveAndCloseClicked($event)">
      {{ 'app.button.label.saveAndClose' | translate }}
    </button>
  </mat-menu>
</div>
} }
